import { useSetRecoilState, useRecoilState, useResetRecoilState } from 'recoil';
import { Apis, Labels } from '../../app.constants';
import { SectorListByNumberAtom, LeadsBySectorAtom, QuetionsBySectorAtom, B2bFormDataAtom } from '../../_states';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../APIService';

const OpsDashboardAction = () => {
	const setSectorListByNumber = useSetRecoilState(SectorListByNumberAtom);
	const [leadListBySector, setLeadsBySector] = useRecoilState(LeadsBySectorAtom);
	const setQuetions = useSetRecoilState(QuetionsBySectorAtom);
	const [b2bFormData, setB2bFormData] = useRecoilState(B2bFormDataAtom);

	const getSectorByNumber = async (number) => {
		let res = await APIService.get(`${Apis.Get_Sector_List}?mobile_number=${number}`)
		if (res.status == 200)
			setSectorListByNumber({ sectors: res?.data?.sectors, total_leads: res?.data?.total_leads })
		else setSectorListByNumber({});
	}
	const getLeadsBySector = async (data) => {
		if (data?.id) {
			let res = await APIService.get(`${Apis.Get_Leads_By_Sector}?mobile_number=${data?.phone_number}&sector_id=${data?.id}`);
			if (res.status == 200)
				setLeadsBySector(res?.data)
		} else {
			setLeadsBySector([])
		}
	}
	const getAllSectors = async () => {
		setLeadsBySector([]);
		let res = await APIService.get(`${Apis.getAllSectors}`)
		if (res?.status === 200)
			setSectorListByNumber({ sectors: res?.data, total_leads: res?.count })
		else setSectorListByNumber({});
	}


	const getQuetionsBySector = async (data) => {
		const sectorName = data?.business_type?.toLowerCase();
		let res = await APIService.get(`${Apis.getQuetionsByNumber}?sector=${sectorName}`)
		if (res.status === 200) {
			let callStatus = res?.data?.call_status?.map((item, index) => {
				return { label: item, value: item }
			})
			let implementationTime = res?.data?.implementation_time?.map((item, index) => {
				return { label: item, value: item }
			})
			let meetingTime = res?.data?.meeting_time?.map((item, index) => {
				return { label: item, value: item }
			})
			let questions = res?.data?.question[0];
			let l4Answer = questions[sectorName]?.L4?.map((item) => {
				if (item)
					return { label: item, value: item }
			})?.filter(Boolean);

			let l5Answer = questions[sectorName]?.L5?.map((item) => {
				if (item)
					return { label: item, value: item }
			})?.filter(Boolean);

			let l6Answer = questions[sectorName]?.L6?.map((item) => {
				if (item)
					return { label: item, value: item }
			})?.filter(Boolean);

			setQuetions({
				companies_sector_wise: res?.data.companies_sector_wise,
				callStatus: callStatus,
				implementationTime: implementationTime,
				meetingTime: meetingTime,
				l4Answer: l4Answer,
				l5Answer: l5Answer,
				l6Answer: l6Answer,
				question: questions
			})
		}
		else setQuetions({})
	}

	const updateLeadData = async (data) => {
		let res = await APIService.put(`${Apis.updateLeadData}`, data);
		if (res?.status === 200) SweetAlert('Data Updated Successfully', Labels?.Success)
		else SweetAlert('Data Not  Updated', 'error')

	}

	const createlead = async (data) => {
		let res = await APIService.post(`${Apis.postLeadData}`, data);
		return res;
	}
	const opsVerifyLead = async (ids) => {
		let res = await APIService.post(`${Apis.opsVerifiedLeads}`, ids)
		if (res?.status === 200) {
			SweetAlert('Ops Verified Successfully', Labels?.Success);
			let updatedArr = leadListBySector.map(item => {
				if (ids?.requirement_ids?.includes(item?.id)) {
					return { ...item, varified_ops: 'Yes' };
				}
				return item;
			});
			setLeadsBySector(updatedArr);
			setB2bFormData({ ...b2bFormData, varified_ops: 'Yes' });
		}
		else SweetAlert('Error', Labels?.Error)
	}

	const getComments = async (id) => {
		let res = await APIService.get(`${Apis.getClientComments}?pre_requirement_id=${id}`)
		if (res?.status === 200) return res?.data;
	}
	const addComment = async (data) => {
		let res = await APIService.post(`${Apis.getClientComments}`, data)
		if (res?.status === 200) SweetAlert(res?.data?.data, Labels?.Success)
		else SweetAlert('Error', Labels?.Error)
	}

	const removeComment = async (commentId, leadId) => {
		let res = await APIService.remove(`${Apis.getClientComments}?pre_requirement_id=${leadId}&id=${commentId}`)
		if (res?.status === 200) SweetAlert(res?.data?.data, Labels?.Success)
		else SweetAlert('Error', Labels?.Error)
	}
	const addInternalComment = async (data) => {
		let res = await APIService.post(`${Apis.getInternalComments}`, data)
		if (res?.status === 200) SweetAlert(res?.data?.data, Labels?.Success)
		else SweetAlert('Error', Labels?.Error)
	}
	const getInteranlComments = async (id) => {
		let res = await APIService.get(`${Apis.getInternalComments}?requirement_id=${id}`)
		if (res?.status === 200) return res?.data;
	}
	const removeInternalComment = async (commentId, leadId) => {
		let res = await APIService.remove(`${Apis.getInternalComments}?requirement_id=${leadId}&id=${commentId}`)
		if (res?.status === 200) SweetAlert(res?.data?.data, Labels?.Success)
		else SweetAlert('Error', Labels?.Error)
	}

	return {
		getSectorByNumber,
		getLeadsBySector,
		getQuetionsBySector,
		updateLeadData,
		getAllSectors,
		createlead,
		opsVerifyLead,
		getComments,
		addComment,
		removeComment,
		getInteranlComments,
		addInternalComment,
		removeInternalComment
	}
}

export { OpsDashboardAction };